// IE判定
var userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
  var elem = document.getElementById('attention');
  elem.style.display = 'block';
}

//slider
const splide = new Splide('.splide', {
  autoplay: true,
  type: 'loop',
  interval: 5000,
  speed: 1000,
  easing: 'ease',
  arrows: false,
  pagination: false,
  breakpoints: {
    937: {
      speed: 500,
    },
  },
}).mount();

// サーバー日付を取得
let today = new Date();
fetch('/').then((response) => {
  today = new Date(response.headers.get('Date'));
});

let loadCash = today.getTime();

// JSONデータ取得
//const dateURL = "//shop.orionbeer.co.jp/cdn/shop/t/187/assets/subscriptionDate.json?v=" + loadCash;
//const productURL = "//shop.orionbeer.co.jp/cdn/shop/t/187/assets/subscriptionProduct.json?v=" + loadCash;

//日付データセット
fetch(dateURL)
  .then((response) => response.json())
  .then((dateData) => {
    dateData.forEach((item) => {
      let startDate = new Date(item.startDate);
      let endDate = new Date(item.endDate);
      let endYear = endDate.getFullYear();
      let endMonth = endDate.getMonth();
      let endDay = endDate.getDate() + 1;
      endDate = new Date(endYear, endMonth, endDay);

      if (startDate < today && endDate > today) {
        let deliveryDate = new Date(item.deliveryDate);
        let day = deliveryDate.getMonth() + 1;
        let endMonth = endDate.getMonth() + 1;
        let endDay = endDate.getDate() - 1;
        let targetDate = `${endMonth}/${endDay}までにお申し込みで、${day}/${deliveryDate.getDate()}にお届け！`;
        var deliveryDayText = document.querySelector('.deliveryDay-text');
        if (deliveryDayText) {
          deliveryDayText.innerHTML = targetDate;
        }

        var deliveryTexts = document.querySelectorAll('.deliveryText');
        if (deliveryTexts) {
          for (let i = 0; i < deliveryTexts.length; i++) {
            deliveryTexts[i].innerHTML = `${endMonth}/${endDay}までにお申し込みで、<br>${day}/${deliveryDate.getDate()}にお届け！`;
          }
        }
      }
    });
  })
  .catch((error) => console.error('日付データ取得エラー:', error));

//商品データセット
fetch(productURL)
  .then((response) => response.json())
  .then((productData) => {
    productData.forEach((data) => {
      //console.log("data", data);
      //calendar
      let startProductDate = new Date(data.startDate);
      let endProductDate = new Date(data.endDate);
      let endProductYear = endProductDate.getFullYear();
      let endProductMonth = endProductDate.getMonth();
      let endProductDay = endProductDate.getDate() + 1;
      endProductDate = new Date(endProductYear, endProductMonth, endProductDay);
      let productMonth = new Date(data.productMonth);

      let deliveryYear = productMonth.getFullYear();
      let deliveryMonth = productMonth.getMonth() + 1;

      //console.log("Today:"+nowDate);

      //src Number
      let srcYear = productMonth.getFullYear();
      let srcMonth = String(productMonth.getMonth() + 1).padStart(2, '0');
      let srcNum = String(srcYear) + String(srcMonth);

      //benefit
      let benefit__flag = data.benefit__flag;
      let novelty__lead = data.novelty__lead;

      //course
      let premium__title1 = data.premium__title1;
      let premium__products1 = data.premium__products1;
      let premium__title2 = data.premium__title2;
      let premium__products2 = data.premium__products2;

      let craft__title1 = data.craft__title1;
      let craft__products1 = data.craft__products1;
      let craft__title2 = data.craft__title2;
      let craft__products2 = data.craft__products2;

      let chuhai__title1 = data.chuhai__title1;
      let chuhai__products1 = data.chuhai__products1;
      let chuhai__title2 = data.chuhai__title2;
      let chuhai__products2 = data.chuhai__products2;

      //毎月､subscriptionProduct(&Date).jsonを更新しないと下記が表示されなくなるので注意

      if (startProductDate < today && endProductDate > today) {
        //ヘッダー部分ノスケジュールテキスト ------------- //
        const month0 = document.getElementById('month0');
        if (month0) {
          month0.innerHTML = deliveryMonth;
        }
        const month3 = document.getElementById('month3');
        if (month3) {
          month3.innerHTML = deliveryMonth;
        }
        const month1 = document.getElementById('month1');
        const month2 = document.getElementById('month2');
        //年またぎの場合の調整
        if (deliveryMonth == 1) {
          month1.innerHTML = 12;
          month2.innerHTML = 11;
        } else if (deliveryMonth == 2) {
          month1.innerHTML = 1;
          month2.innerHTML = 12;
        } else {
          month1.innerHTML = deliveryMonth - 1;
          month2.innerHTML = deliveryMonth - 2;
        }

        //ie-nomi POINT ------------- //
        const ieNnomi1 = document.getElementById('ie-nomi1');
        const ieNnomi2 = document.getElementById('ie-nomi2');
        if (ieNnomi1) {
          ieNnomi1.innerHTML = `<picture><source media="(max-width: 937px)" srcset="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subsc2022_section08_img_sp_${srcNum}.jpg?v=${loadCash}"><img src="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subsc2022_section08_img_pc_${srcNum}.png?v=${loadCash}" width="920" height="364" loading="lazy" alt="【POINT1：限定品や新製品を優先的にお届け】オリオンビールでは、新商品を日々開発。沖縄県外ではなかなか味わえない限定品を、優先的にお届けします。"></picture>`;
        }
        if (ieNnomi2) {
          ieNnomi2.innerHTML = `<picture><source media="(max-width: 937px)" srcset="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subsc2022_section09_img_sp_${srcNum}.jpg?v=${loadCash}"><img src="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subsc2022_section09_img_pc_${srcNum}.png?v=${loadCash}" width="920" height="376" loading="lazy" alt="【POINT2：会員限定の特典やオリジナルグッズ】オリオングッズや沖縄グルメが10%OFF!さらにオリオンビール名護工場の先行予約などもございます。"></picture>`;
        }
        //section11 色々な沖縄を楽しめる!だから選ばれています！ ------------- //
        //document.getElementById('section11-1').innerHTML = `<picture><source media="(max-width: 937px)" srcset="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subsc2022_section11_img01_sp_${srcNum}_re.png?v=${loadCash}"><img src="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subsc2022_section11_img01_pc_${srcNum}_re.png?v=${loadCash}" width="300" height="518" loading="lazy" alt="ザ・ドラフト：沖縄クラフトの定番。伊江島産大麦や沖縄の軟水やんばるの水を使用。「沖縄の気候に合ったのどごし」を追求しています。"></picture>`;
        //document.getElementById('section11-2').innerHTML = `<picture><source media="(max-width: 937px)" srcset="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subsc2022_section11_img02_sp_${srcNum}_re.png?v=${loadCash}"><img src="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subsc2022_section11_img02_pc_${srcNum}_re.png?v=${loadCash}" width="300" height="518" loading="lazy" alt="オリオン ザ・プレミアム：話題の新商品。沖縄の自然から発見した新ビール酵母がつくりだすプレミアムビール。華やかでフルーティーな香りと、コクはあるのに苦味が少ない味わい。"></picture>`;
        //document.getElementById('section11-3').innerHTML = `<picture><source media="(max-width: 937px)" srcset="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subsc2022_section11_img03_sp_${srcNum}_re.png?v=${loadCash}"><img src="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subsc2022_section11_img03_pc_${srcNum}_re.png?v=${loadCash}" width="300" height="518" loading="lazy" alt="75BEER IPA：大人気のビアスタイル「IPA」。5種のホップを贅沢に使用し沖縄県名護産のシークヮーサーを加えることで、上質な苦味と華やかな香りが広がります。"></picture>`;

        //novelty 今月だけの新規お申し込み特典 ------------- //
        const noveltyLead = document.getElementById('novelty__lead');
        if (noveltyLead) {
          noveltyLead.innerHTML = novelty__lead;
        }
        const noveltyImg1 = document.querySelector('.novelty_img1');
        if (noveltyImg1) {
          noveltyImg1.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subscription3_novelty_img_${srcNum}_420x.png?v=${loadCash}" width="420" height="172" loading="lazy" alt="">`;
        }
        const noveltyImg2 = document.querySelector('.novelty_img2');
        if (noveltyImg2) {
          if (benefit__flag == 'true') {
            document.querySelector('.novelty_img2').innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subscription3_novelty_img_limited_${srcNum}_420x.png?v=${loadCash}" width="420" height="172" loading="lazy" alt="">`;
          } else {
            document.querySelector('.novelty_img2').remove();
          }
        }

        //course ------------- //
        const circles = document.querySelectorAll('.productImg .circle');
        circles.forEach((circle) => {
          circle.innerHTML = `${deliveryYear}年<br>${deliveryMonth}月の<br>お届け商品`;
        });
        //01 Premium
        document.querySelector('#premium .productImg .img').innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subscription3_course_premium_${srcNum}_360x.png?v=${loadCash}" width="180" height="165" loading="lazy" alt="">`;
        document.getElementById('premium__title1').innerHTML = premium__title1;
        document.getElementById('premium__products1').innerHTML = `<b>${premium__products1}</b>`;
        document.getElementById('premium__title2').innerHTML = premium__title2;
        document.getElementById('premium__products2').innerHTML = premium__products2;
        if (premium__products2 == '') {
          document.getElementById('premium__title2').remove();
        }

        //02 Craft
        document.querySelector('#craft .productImg .img').innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subscription3_course_craft_${srcNum}_360x.png?v=${loadCash}" width="180" height="165" loading="lazy" alt="">`;
        document.getElementById('craft__title1').innerHTML = craft__title1;
        document.getElementById('craft__products1').innerHTML = `<b>${craft__products1}</b>`;
        document.getElementById('craft__title2').innerHTML = craft__title2;
        document.getElementById('craft__products2').innerHTML = craft__products2;

        //03 Chuhai
        document.querySelector('#chuhai .productImg .img').innerHTML = `<img src="https://cdn.shopify.com/s/files/1/0362/3052/9157/files/subscription3_course_chuhai_${srcNum}_360x.png?v=${loadCash}" width="180" height="165" loading="lazy" alt="">`;
        document.getElementById('chuhai__title1').innerHTML = chuhai__title1;
        document.getElementById('chuhai__products1').innerHTML = `<b>${chuhai__products1}</b>`;
        document.getElementById('chuhai__title2').innerHTML = chuhai__title2;
        document.getElementById('chuhai__products2').innerHTML = chuhai__products2;
      }
    });
  })
  .catch((error) => console.error('商品データ取得エラー:', error));

//slide

//FAQ
const toggleAction = (el) => {
  el.classList.toggle('active');
  const target = el.nextElementSibling;
  if (target.style.maxHeight) {
    target.style.maxHeight = null;
    target.inert = true;
  } else {
    target.inert = false;
    target.style.maxHeight = target.scrollHeight + 'px';
  }
};

// FAQの開閉
let lastKeyWasTab = false;

document.addEventListener('keydown', function (e) {
  lastKeyWasTab = e.key === 'Tab';
});

const faqList = document.querySelectorAll('.faq__list .toggle');
if (faqList) {
  faqList.forEach((toggle) => {
    toggle.addEventListener('click', function (e) {
      toggleAction(toggle); // clickでは常に動作
    });

    toggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // Spaceによるスクロール防止
        toggleAction(toggle);
      }
    });

    toggle.addEventListener('focus', function () {
      // 最後のキーがTabだった場合のみトグル（マウスクリック直後のfocusを除外）
      if (lastKeyWasTab) {
        // toggleAction(toggle); ← もし「Tabだけで開く」ならここで実行
        // 今回は実行しないので、focusはスタイルだけに使うならここは空でOK
      }
    });
  });
}

//tab
document.querySelectorAll('.priceSelect__item').forEach((item) => {
  item.addEventListener('click', () => {
    // 親の .priceSelect を取得
    const priceSelect = item.closest('.priceSelect');
    // すべての .priceSelect__item から active クラスを削除
    priceSelect.querySelectorAll('.priceSelect__item').forEach((el) => el.classList.remove('active'));
    // クリックした要素に active クラスを追加
    item.classList.add('active');
    // 対応する .priceBox の表示を切り替える
    const target = priceSelect.nextElementSibling;
    if (target && target.classList.contains('target')) {
      const priceBoxes = target.querySelectorAll('.priceBox');

      // すべての .priceBox から active クラスを削除
      priceBoxes.forEach((box) => {
        box.classList.remove('active');
        box.inert = true;
      });

      // クリックした要素のインデックスを取得
      const index = Array.from(priceSelect.children).indexOf(item);

      // 対応する .priceBox に active クラスを追加
      if (priceBoxes[index]) {
        priceBoxes[index].classList.add('active');
        priceBoxes[index].inert = false;
      }
    }
  });
});

// ---------------------------------------
var uqid = '78976R94cd9Sb05S';
var cid = '272';
var a = document.createElement('script');
a.dataset.uqid = uqid;
a.dataset.cid = cid;
a.id = 'afadfpc-78976R94cd9Sb05Scid255-' + Date.now();
a.src = '//tag.ecnavi-tracking.jp/fpc/cookie_js.php?scriptId=' + encodeURIComponent(a.id);
document.head.appendChild(a);
// ---------------------------------------
